import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TargetAudienceSection } from '../components/sections/TargetAudienceSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { CourseContentSection } from '../components/sections/CourseContentSection';
import { CourseFeaturesSection } from '../components/sections/CourseFeaturesSection';
import { PricingSection } from '../components/sections/PricingSection';
import { BonusesSection } from '../components/sections/BonusesSection';
import { SecuritySection } from '../components/sections/SecuritySection';
import { AboutSection } from '../components/sections/AboutSection';
import { VideoGallerySection } from '../components/sections/VideoGallerySection';
import { FAQSection } from '../components/sections/FAQSection';
import { StickyCTA } from '../components/StickyCTA';
import { LivePurchaseNotification } from '../components/LivePurchaseNotification';
import { WhatsAppFloatingButton } from '../components/WhatsAppFloatingButton';
import { TopBanner } from '../components/TopBanner';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-950 font-sans selection:bg-blue-900 selection:text-blue-200" data-id="element-234">
      <TopBanner data-id="element-235" />
      <HeroSection data-id="element-236" />
      <TargetAudienceSection data-id="element-237" />
      <TestimonialsSection data-id="element-238" />
      <CourseContentSection data-id="element-239" />
      <CourseFeaturesSection data-id="element-240" />
      <PricingSection data-id="element-241" />
      <BonusesSection data-id="element-242" />
      <SecuritySection data-id="element-243" />
      <AboutSection data-id="element-244" />
      <VideoGallerySection data-id="element-245" />
      <FAQSection data-id="element-246" />

      {/* Footer minimalista */}
      <footer className="bg-black py-8 text-center text-slate-500 text-sm px-4" data-id="element-247">
        <p data-id="element-248">
          © {new Date().getFullYear()} Bruno. Todos los derechos reservados.
        </p>
        <p className="mt-2" data-id="element-249">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <StickyCTA data-id="element-250" />
      <WhatsAppFloatingButton data-id="element-251" />
    </div>;
}